module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home__nav2"
  }, [_c('div', {
    staticClass: "home__container nav"
  }, [_c('div'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'services'
      }
    }
  }, [_c('button', {
    staticClass: "dropbtn"
  }, [_vm._v(_vm._s(_vm.$t('Services')))])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-content"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'services'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Services')))])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'pricing'
      }
    }
  }, [_c('button', {
    staticClass: "dropbtn"
  }, [_vm._v(_vm._s(_vm.$t('Pricing')))])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-content"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'pricing'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Pricing')))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'quote-request'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Quote_request')))])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_c('button', {
    staticClass: "dropbtn"
  }, [_vm._v(_vm._s(_vm.$t('The_company')))])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-content"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('About_us')))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'our-clients'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Our_clients')))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'philosophy'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Philosophy')))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'customer-service'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Customer_Service')))])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_c('button', {
    staticClass: "dropbtn"
  }, [_vm._v(_vm._s(_vm.$t('Contact')))])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-content"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Contact')))])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dropdown"
  }, [_c('button', {
    staticClass: "dropbtn"
  }, [_vm._v(_vm._s(_vm.$t('Language')))]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-content"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.setLanguage('ca')
      }
    }
  }, [_vm._v("Català")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.setLanguage('es')
      }
    }
  }, [_vm._v("Castellano")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.setLanguage('en')
      }
    }
  }, [_vm._v("English")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2a6a54e9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBar.vue
// module id = 2124
// module chunks = 0